<template>
  <router-link
    :to="{name: 'DashboardMessages'}"
    title="Consulter votre messagerie COOLOC"
    class="mobile-only messages-header">
    <div>
      <span class="chat-icon"></span>
      <span v-if="nb_unread > 0" class="counter">{{ nb_unread }}</span>
    </div>
  </router-link>
</template>

<script>
import unreadCountMixin from '../mixins/unreadCount'
export default {
  mixins: [unreadCountMixin],
  name: 'messages-header',
}
</script>
